import { render, staticRenderFns } from "./OtherAccount.vue?vue&type=template&id=aa35822e&scoped=true"
import script from "./OtherAccount.vue?vue&type=script&lang=js"
export * from "./OtherAccount.vue?vue&type=script&lang=js"
import style0 from "./OtherAccount.vue?vue&type=style&index=0&id=aa35822e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa35822e",
  null
  
)

export default component.exports